import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import SelectTopK from './SelectTopK';
import ShowMetadataSelector from "./ShowMetaDataSelector";
// import SelectTopProductCategories from "./SelectTopProductCategories";
import ShowProductCategories from "./ShowProductCategories";


const Config = () => {
    const { t } = useTranslation()

    return (
        <div className="card card-body m-2 p-2" style={{ width: "12em" }}>
            <SelectTopK></SelectTopK>
            <ShowProductCategories></ShowProductCategories>
            {/* <SelectTopProductCategories></SelectTopProductCategories> */}
            <ShowMetadataSelector></ShowMetadataSelector>
            <Link to="/"><button className='btn btn-secondary'>{t('Button.back')}</button></Link>
        </div>
    )
}

export default Config